<script>
export default {
  data() {
    return {
      open: false,
    };
  },
  methods: {
    handleClickOutside(event) {
      const customSelect = this.$el;
      if (!customSelect.contains(event.target)) {
        this.open=false;
      }
    },
    changeLanguage(locale){
      this.$i18n.locale=locale;
      localStorage.setItem("locale", locale);
      this.open=false;
    }
  },
  mounted() {
    this.changeLanguage(localStorage.getItem("locale") || "fr")
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>

<template>
  <div class="custom-select" @blur="open = false">
    <div class="selected" :class="{ open: open }" @click="open = !open">
      {{ $i18n.locale }}
    </div>
    <div class="items" :class="{ selectHide: !open }">
      <div
        v-for="locale of $i18n.availableLocales"
        :key="`locale-${locale}`"
        @click="changeLanguage(locale)"
      >
        {{ locale }}
      </div>
    </div>
  </div>
</template>
<style scoped>
.custom-select {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  text-align: left;
  outline: none;
  height: 35px;
  line-height: 35px;
  color: var(--text);
  border-radius: 40px;
  font-size: 1.2rem;
  z-index: 5;
}

.custom-select .selected {
  background-color: transparent;
  border-radius: 6px;
  color: var(--text);
  font-weight: bold;
  cursor: pointer;
  user-select: none;
  text-transform: uppercase;
  transition: all .2s ease-in-out;
}

.custom-select .selected.open {
  border-radius: 6px;
}

.custom-select .items {
  overflow: hidden;
  position: absolute;
  background-color: var(--bg);
  text-transform: uppercase;
  border-radius: 10px;
  top: 40px;
  left: 0;
  right: 0;
  z-index: 5;
  border:1px solid var(--bg);
}

.custom-select .items div {
  color: var(--text-medium-emphasis);
  text-align: center;
  cursor: pointer;
  user-select: none;
  padding:.5rem 0;
  border-radius: 10px;
}

.custom-select .items div:hover {
  background-color: var(--bg2);
}

.selectHide {
  display: none;
}
</style>
